let logo = 'data:image/svg+xml;base64,PHN2ZyBpZD0iYjI5OTdmMzktODllNi00ZTJkLWIwZDgtMzY4NzY2ZDA5ZGQ4IiBkYXRhLW5hbWU9Iklzb2xhdGlvbiBNb2RlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNCAzNCI+CiAgPHBhdGggZmlsbD0iIzcwNDdFQiIgZD0iTTAgMTdjMC01LjI4IDAtNy45Mi44Ni0xMEExMS4zMyAxMS4zMyAwIDAgMSA3IC44NkM5LjA4IDAgMTEuNzIgMCAxNyAwczcuOTIgMCAxMCAuODZBMTEuMzMgMTEuMzMgMCAwIDEgMzMuMTQgN2MuODYgMi4wOC44NiA0LjcyLjg2IDEwczAgNy45Mi0uODYgMTBBMTEuMzMgMTEuMzMgMCAwIDEgMjcgMzMuMTRjLTIuMDguODYtNC43Mi44Ni0xMCAuODZzLTcuOTIgMC0xMC0uODZBMTEuMzMgMTEuMzMgMCAwIDEgLjg2IDI3QzAgMjQuOTIgMCAyMi4yOCAwIDE3WiIvPgogIDxwYXRoIGZpbGw9IndoaXRlIiBkPSJNMy40IDIxLjI1IDIwLjQgMHY4LjY4YTQuMDcgNC4wNyAwIDAgMCA0LjA3IDQuMDdoNS44NUwxMy4zMiAzNHYtOC42OGE0LjA3IDQuMDcgMCAwIDAtNC4wNy00LjA3SDMuNFoiLz4KPC9zdmc+Cg==';


import Vue from 'vue';
import Chart from 'vue2-frappe';
import VueTippy, { TippyComponent } from 'vue-tippy';
import VueLogger from 'vuejs-logger';
import { sync } from 'vuex-router-sync';

import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

import App from '@/App.vue';
import store from '@/store';
import router from '@/router';

import { IMaskDirective } from 'vue-imask';
import vPreventBodyScroll from '@/directives/prevent-body-scroll';
import windowSizeToStore from '@/directives/window-size-to-store.js';
import { checkAuth } from '@/utilites';
// old ui
import NiceIcon from '@/ui/nice-icon';
import NiceButton from '@/ui/nice-button';
// new ui
import NiceButton2 from '@/ui/nice-button-2';
import NiceIcon2 from '@/ui/nice-icon-2';
import NiceLabel from '@/ui/nice-label';

import { i18n } from '@/i18n.js';
// w/o tokens
// TODO: we need a model for uioverrides
import { get_uioverrides } from '@/api/request';
import { enableUIOverrides } from '@/uioverrides';

// toasted notifications
import Toasted from 'vue-toasted';

// loading circle
import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

// custom plugins
import FiltersPlugin from '@/plugins/filters.js';
import AsyncSet from '@/plugins/async-set.js';

// yandex metrika
import VueYandexMetrika from 'vue-yandex-metrika';

// Mixpanel
// TODO: move into a plugin?
// import mixpanel from 'mixpanel-browser';
// async components
import mixpanel from 'mixpanel-browser/src/loaders/loader-module-with-async-modules';
if (process.env.VUE_APP_MIXPANEL_TOKEN) {
	mixpanel.init(process.env.VUE_APP_MIXPANEL_TOKEN, {
		debug: process.env.VUE_APP_MIXPANEL_DEBUG || false,
		autocapture: process.env.VUE_APP_MIXPANEL_AUTOCAPTURE || true,
		track_pageview: process.env.VUE_APP_MIXPANEL_TRACK_PAGEVIEW || false,
		record_heatmap_data: process.env.VUE_APP_MIXPANEL_RECORD_HEATMAP_DATA || false,
		record_sessions_percent: process.env.VUE_APP_MIXPANEL_RECORD_SESSIONS_PERCENT,
		persistence: 'localStorage',
	});
}

// imask directive
Vue.directive('imask', IMaskDirective);

// Apply filters plugin
Vue.use(FiltersPlugin);
Vue.use(AsyncSet);

Vue.config.productionTip = false;

// logger
Vue.use(VueLogger, {
	isEnabled: true,
	logLevel: process.env.VUE_APP_LOG_LEVEL,
	stringifyArguments: false,
	showLogLevel: true,
	showMethodName: true,
	separator: '|',
	showConsoleColors: true
});

// error logging in sentry
window.Sentry = Sentry;
if (process.env.VUE_APP_SENTRY_DSN) {
	Sentry.init({
		dsn: process.env.VUE_APP_SENTRY_DSN,
		// TODO: sentry has new recommended setup
		integrations: [
			new Integrations.Vue({Vue, attachProps: true}),
		],
	});
}


// apply frappe component
Vue.use(Chart);

// toasted notifications
Vue.use(Toasted);

// apply Tippy
Vue.use(VueTippy, {
	animateFill: false,
	animation: 'fade',
	arrow: true,
	duration: 100,
	theme: 'nice',
	flipDuration: 0,
	// popperOptions: {
	// 	modifiers: {
	// 		preventOverflow: { enabled: false, },
	// 		hide: { enabled: false, },
	// 	},
	// },
});

Vue.component('Tippy', TippyComponent);


// directives
Vue.directive('windowSizeToStore', windowSizeToStore);
Vue.use(vPreventBodyScroll);


// UI
// old
Vue.component('NiceIcon', NiceIcon);
Vue.component('NiceButton', NiceButton);
// new
Vue.component('NiceButton2', NiceButton2);
Vue.component('NiceIcon2', NiceIcon2);
Vue.component('NiceLabel', NiceLabel);


// inject `$router` into the `store` object
store.$router = router;


// need to be after our hacks with router and store
// eslint-disable-next-line
const unsync = sync(store, router);

// chain pre vue checks and calls
Promise.all([
	checkAuth(store),
	// TODO: we need a model for uioverrides
	get_uioverrides(),
]).then(values => {
	// check and set language for WL domain
	const overrides = values[1].data || {};

	if (overrides.available_locales) {
		store.commit('profile/setAvailableLocales', overrides.available_locales);
	}

	if (overrides.default_language && !store.getters['profile/isLanguageSet']) {
		store.commit('profile/setLanguage', overrides.default_language);

		// reget UI override settings with a correct language
		return get_uioverrides();
	}

	return values[1];
}).then(overridesResponse => {
	let getProfilePromise = true;
	if (store.state.app.agency && store.state.profile.token) {
		getProfilePromise = store.dispatch('profile/getProfile', true);
	}

	const overrides = overridesResponse.data || {};

	// TODO: set available_locales again?
	if (overrides.available_locales) {
		store.commit('profile/setAvailableLocales', overrides.available_locales);
	}

	enableUIOverrides(Vue, store, overrides);

	// loading circle
	Vue.use(VueLoading, {
		color: overrides.main_color || '#7047EB',
		isFullPage: false,
		opacity: 0,
		enforceFocus: false,
	});

	// apply yandex metrika
	const yandex_metrika_id = overrides.yandex_metrika_id || process.env.VUE_APP_YANDEX_METRIKA;
	if (yandex_metrika_id) {
		Vue.use(VueYandexMetrika, {
			id: yandex_metrika_id,
			router: router,
			env: process.env.NODE_ENV // Metrika turns on only if `env` is 'production'
		});
	}

	// just to show in the console
	if (overrides.logo) {
		logo = overrides.logo;
	}

	return getProfilePromise;
}).then(() => {
	console.log( // eslint-disable-line no-console
		'%c+',
		`font-size: 1px; padding: 27px; line-height: 0; background: url("${logo}"); background-size: 34px 34px; background-repeat: no-repeat; background-position: center; color: transparent;`
	);
	console.debug( // eslint-disable-line no-console
		`%c ${process.env.VUE_APP_CURRENT_GIT_BRANCH} %c ${process.env.VUE_APP_CURRENT_GIT_COMMIT} %c`,
		'background: #35495e; padding: 1px; border-radius: 3px 0 0 3px; color: #fff',
		'background: #41b883; padding: 1px; border-radius: 0 3px 3px 0; color: #fff',
		'background:transparent'
	);

	// start vue
	new Vue({
		i18n,
		router,
		store,
		render: h => h(App),
	}).$mount('#app');
});
